"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HR_ROLES = void 0;
var HR_ROLES;
(function (HR_ROLES) {
    HR_ROLES["SEARCH_EMPLOYEES"] = "search-employees";
    HR_ROLES["VIEW_EMPLOYEE"] = "view-employee";
    HR_ROLES["CREATE_EMPLOYEE"] = "create-employee";
    HR_ROLES["MODIFY_EMPLOYEE"] = "modify-employee";
    HR_ROLES["SEARCH_SEATS"] = "search-seats";
    HR_ROLES["VIEW_SEAT"] = "view-seat";
    HR_ROLES["CREATE_SEAT"] = "create-seat";
    HR_ROLES["MODIFY_SEAT"] = "modify-seat";
    HR_ROLES["ASSIGN_EMPLOYEE_TO_SEAT"] = "assign-employee-to-seat";
    HR_ROLES["VIEW_ORG_CHART"] = "view-org-chart";
})(HR_ROLES = exports.HR_ROLES || (exports.HR_ROLES = {}));
//# sourceMappingURL=hr.roles.js.map